import React from 'react';

import { StyledDatePicker } from '@/components/form/StyledDatePicker';

interface PeriodOfPerformanceProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  disabled?: boolean;
  required?: boolean;
  showTitle?: boolean;
  className?: string;
  filterStartDate?: (date: Date) => boolean;
}

export const PeriodOfPerformance: React.FC<PeriodOfPerformanceProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled = false,
  required = false,
  showTitle = true,
  className = '',
  filterStartDate,
}) => {
  return (
    <div className={className}>
      {showTitle && (
        <h3 className="text-chariot-text-primary mb-6 text-base font-medium">
          Period of Performance{' '}
          {required && <span className="text-chariot-stroke-critical">*</span>}
        </h3>
      )}
      <div className="grid grid-cols-2 gap-4">
        <StyledDatePicker
          label="Start Date"
          name="subscription_start_date"
          value={startDate}
          onChange={onStartDateChange}
          disabled={disabled}
          required={required}
          max={endDate || undefined}
          filterDate={filterStartDate}
        />
        <StyledDatePicker
          label="End Date"
          name="subscription_end_date"
          value={endDate}
          onChange={onEndDateChange}
          disabled={disabled}
          required={required}
          min={startDate || undefined}
        />
      </div>
    </div>
  );
};
